<template>
  <div v-if="!loading">
    <d-header
      fluid
      :breadcrumbs="false"
      :actions="[{
        label: $t('save'),
        primary: true,
        color: 'is-primary',
        action: submitForm
      }]"
    >
      <h1 class="title">
        {{ model.name }}
      </h1>
    </d-header>
    <v-form
      ref="form"
      action="edit"
      :model="model"
    />
  </div>
</template>

<script>
import form from "./_form.vue";

export default {
  metaInfo() {
    return {
      title: this.title,
      __application_file: this.title // for breadcrumb
    };
  },
  components: {
    "v-form": form
  },
  data () {
    return {
      model: {},
      loading: true
    };
  },
  computed: {
    title () {
      if (this.model.name) {
        return this.model.name;
      }
      return "";
    }
  },
  watch: {
    "$route.params.applicationFile" () {
      this.fetch();
    }
  },
  created () {
    this.fetch();
  },
  methods: {
    fetch () {
      this.loading = true;
      this.$http.get(this.$laravel.route("api.application-files.show", {
        property: this.$route.params.property,
        application_file: this.$route.params.applicationFile
      }))
        .then(response => {
          this.loading = false;
          this.model = response.data.data;
        })
        .catch((e) => {
          console.error(e);
          this.$router.push("/properties/"+this.$route.params.property+"/application-files");
        });
    },
    submitForm () {
      this.$refs.form.$refs.form.submit();
    }
  }
};
</script>
